import React, { Fragment } from "react";
import Button from "./Button";
import {
    BellAlertIcon,
    EllipsisHorizontalCircleIcon,
    PencilSquareIcon,
    TrashIcon,
} from "@heroicons/react/24/outline";
import { Menu, Transition } from "@headlessui/react";

const FireAlarmSystemCard = ({
    fireAlarmSystem,
    isEditState,
    onClickView,
    onClickEdit,
    onClickDelete = () => { },
    hideDelete = false,
    hasDeletePermission,
    onClickRemove = () => { },
    hideRemove = false,
    editHidden = false,
}) => {
    return (
        <>
            <div className="bg-white border border-gray-200 shadow-md  rounded-md">
                <div className="flex w-full items-start p-2 gap-x-2">
                    <div className="mt-3">
                        {" "}
                        <BellAlertIcon className="text-blue-500 h-6 w-6" />
                    </div>
                    <div className="w-full truncate">
                        <div className="flex flex-row">
                            <h3 className="text-xs1 items-center flex font-normal text-gray-400">
                                <svg
                                    className={
                                        fireAlarmSystem.isActive === true
                                            ? "text-green-500 mr-1 talic h-2 w-2"
                                            : " text-gray-40 -ml-0.5 mr-1 talic h-2 w-2"
                                    }
                                    fill="currentColor"
                                    viewBox="0 0 8 8"
                                >
                                    <circle cx={4} cy={4} r={3} />
                                </svg>{" "}
                                {fireAlarmSystem.isActive === true ? "Active" : "Inactive"}
                            </h3>
                        </div>
                        <div
                            onClick={() => {
                                onClickView();
                            }}
                            className={`text-gray-600 font-medium flex flex-row justify-between blueAndBold ${isEditState ? "" : "cursor-pointer"
                                }`}
                        >
                            <h1 className="mr-auto truncate text-ellipsis font-bold text-quinary text-base underline uppercase">
                                {fireAlarmSystem.vendorName ? fireAlarmSystem.vendorName : "No Vendor"}
                            </h1>
                        </div>
                        <h2 className="text-xxs  text-gray-600 truncate">
                            {fireAlarmSystem.alarmTypeName ? fireAlarmSystem.alarmTypeName : "Unknown Type"}
                        </h2>
                        <h2 className="text-xxs text-gray-600 truncate">
                            {fireAlarmSystem.vendorPhone !== "null"
                                ? fireAlarmSystem.vendorPhone
                                : "No Vendor Phone "}
                        </h2>
                        <h2 className="text-xs font-bold text-gray-600 truncate ">
                            {fireAlarmSystem.vendorAccountNumber == null || fireAlarmSystem.vendorAccountNumber == ""
                                ? "No Account # "
                                : fireAlarmSystem.vendorAccountNumber}
                        </h2>
                    </div>
                    {isEditState && (
                        <div className="flex justify-end w-25">
                            <Menu as="div" className="flex">
                                <div>
                                    <Menu.Button className="">
                                        <EllipsisHorizontalCircleIcon
                                            className="h-4 w-4 text-primary rounded-full hover:bg-primary hover:text-white"
                                            aria-hidden="true"
                                        />
                                    </Menu.Button>
                                </div>
                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <Menu.Items className=" absolute z-50 mt-2 w-24 origin-top-right divide-y divide-gray-100 rounded-md   bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        {!editHidden && (
                                            <div className="px-1 py-1">
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <button
                                                            className={""}
                                                            onClick={() => {
                                                                onClickEdit();
                                                            }}
                                                            disabled={false}
                                                        >
                                                            <label className="flex flex-cols underline cursor-pointer text-quaternary text-xs fontLabel font-semibold ">
                                                                {" "}
                                                                <PencilSquareIcon className="h-4 w-4  text-quaternary" />{" "}
                                                                Edit
                                                            </label>
                                                        </button>
                                                    )}
                                                </Menu.Item>
                                            </div>
                                        )}

                                        {!hideDelete &&
                                            hasDeletePermission &&
                                            fireAlarmSystem.isActive === true &&
                                            typeof onClickDelete === "function" && (
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <button
                                                            className={""}
                                                            onClick={() => {
                                                                onClickDelete();
                                                            }}
                                                            disabled={false}
                                                        >
                                                            <label className="flex flex-cols underline cursor-pointer text-secondary text-xs fontLabel font-semibold ">
                                                                <TrashIcon className="h-4 w-4 text-secondary" />{" "}
                                                                Deactivate
                                                            </label>
                                                        </button>
                                                    )}
                                                </Menu.Item>
                                            )}
                                        {!hideRemove && typeof onClickRemove === "function" && (
                                            <div className="px-1 py-1">
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                onClickRemove();
                                                            }}
                                                        >
                                                            <label className="flex flex-cols underline cursor-pointer text-red-600 text-xs fontLabel font-semibold">
                                                                <TrashIcon className="h-4 w-4 text-red-600" />
                                                                Remove
                                                            </label>
                                                        </button>
                                                    )}
                                                </Menu.Item>
                                            </div>
                                        )}
                                    </Menu.Items>
                                </Transition>
                            </Menu>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default FireAlarmSystemCard;
